import { render, staticRenderFns } from "./ParagraphItem.vue?vue&type=template&id=e1cd5366&scoped=true&"
import script from "./ParagraphItem.vue?vue&type=script&lang=js&"
export * from "./ParagraphItem.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e1cd5366",
  null
  ,true
)

export default component.exports